'use client';

import { useOptimistic } from 'react';
import type { CheckoutType } from '../../../helpers/set-state-cookie';
import type { CitiesQuery } from '../../../types/generated';
import { CityField } from '../city-field';
import { ZipCodeField } from '../zip-code-field';
import { submitZipCode } from './server-functions';

type ZipCodeAndCityFieldProps = {
  checkoutType: CheckoutType;
  cities?: CitiesQuery['citiesByPostcode'];
  cityDefaultValue?: string;
  invalidZip?: boolean;
  zipCodeDefaultValue?: string;
  cityLabel?: string;
  zipCodeLabel?: string;
};

export const ZipCodeAndCityFieldClient: React.FC<ZipCodeAndCityFieldProps> = ({
  checkoutType,
  cities,
  cityDefaultValue,
  invalidZip,
  zipCodeDefaultValue,
  cityLabel,
  zipCodeLabel,
}) => {
  const [optimisticState, addOptimisticState] = useOptimistic(
    {
      cities: cities ?? [],
    },
    (state, cities: CitiesQuery['citiesByPostcode'] | []) => ({
      ...state,
      cities: cities || [],
    }),
  );

  return (
    <>
      <ZipCodeField
        defaultValue={zipCodeDefaultValue}
        invalidZip={Boolean(invalidZip)}
        name="zip"
        label={zipCodeLabel}
        submitAction={(zip) => {
          addOptimisticState([]);
          submitZipCode(checkoutType, zip);
        }}
      />

      <CityField cities={optimisticState.cities} defaultValue={cityDefaultValue} name="city" label={cityLabel} />
    </>
  );
};
